/*
 * This file contains KitBuilder UI changes that couldn't be easily done using CSS.
 *
 * Each UI change should use the repeatUntilTrueOrMaxAttempts function. Pass it a
 * function that looks for the KB elements and returns true when it is successful.
 */

var ELEMENT_SEARCH_INTERVAL = 500;
var MAX_SEARCH_ATTEMPTS = 15;
var MOBILE_MAX_WIDTH = 991; // Make sure this agrees with values in kb-styles.scss
var ALLOWED_FILE_MIME_TYPES = 'image/jpeg,image/png';

/*
 * Helper functions
 */

// Calls handler every ELEMENT_SEARCH_INTERVAL milliseconds,
// until handler returns true or it reaches MAX_SEARCH_ATTEMPTS attempts.
var repeatUntilTrueOrMaxAttempts = function (handler) {
    var intervalId = null;
    var count = 0;

    var done = function () {
        clearInterval(intervalId);
    };

    var handlerWrapper = function () {
        if (handler() || count++ > MAX_SEARCH_ATTEMPTS) {
            done();
        }
    };

    intervalId = setInterval(handlerWrapper, ELEMENT_SEARCH_INTERVAL, done);
};

// Returns true if screen width less than MOBILE_MAX_WIDTH
var isMobile = function () {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
};

// Animates a scroll lasting {time} milliseconds to the top of {$element}
var scrollToElement = function ($element, time) {
    $('html, body').animate({
        scrollTop: $element.offset().top,
    }, time);
};

/*
 * UI Hacks below
 */

// Move design name to product heading
repeatUntilTrueOrMaxAttempts(function () {
    var $designNameElement = $('.kb-preview-design-name').first();
    var $productHeadingElement = $('.kb-customise-product-heading').first();

    if ($designNameElement && $productHeadingElement) {
        $productHeadingElement.append($designNameElement);

        // return true;
    }
});

// Add transparent overlays to the sides of the canvas to allow easy scrolling
repeatUntilTrueOrMaxAttempts(function () {
    var $kb3dWrapper = $('.kb-3d-wrapper').first();

    if ($kb3dWrapper.length) {
        var $leftBumper = $('<div></div>').addClass('fe-canvas-touch-bumper').
            addClass('fe-canvas-touch-bumper--left');
        var $rightBumper = $('<div></div>').addClass('fe-canvas-touch-bumper').
            addClass('fe-canvas-touch-bumper--right');
        var $topBumper = $('<div></div>').addClass('fe-canvas-touch-bumper').
            addClass('fe-canvas-touch-bumper--top');
        var $bottomBumper = $('<div></div>').addClass('fe-canvas-touch-bumper').
            addClass('fe-canvas-touch-bumper--bottom');

        $kb3dWrapper.prepend($rightBumper);
        $kb3dWrapper.prepend($leftBumper);
        $kb3dWrapper.prepend($topBumper);
        $kb3dWrapper.prepend($bottomBumper);

        return true;
    }
});

// Automatic preview and view back of model when changing player name/number
// This is called every time the user clicks Add Player (see below)
var automaticPreviewViewBackOnPlayerNameOrNumberChange = function () {
    var $playerRows = $('.kb-units-table .kb-table-row');
    var $changeViewButtons = $('.kb-overlay-button.kb-change-view-button');

    if ($playerRows.length && $changeViewButtons.length) {
        $playerRows.each(function () {
            var $playerRow = $(this);
            var $name = $playerRow.find('.kb-unit-name .kb-text-box').first();
            var $number = $playerRow.find('.kb-unit-number .kb-text-box').first();
            var $previewButton = $playerRow.find('.kb-unit-preview .kb-preview').first();

          
            var onKeyUp = function () {
                // Must use angular here, $(el).trigger('click') does not work
                // and $(el).click() doesn't let us differentiate between script and user clicks
                window.angular.element($previewButton[0]).trigger('click', ['AutoPreview']);

                $changeViewButtons.each(function () {
                    var $button = $(this);
                    if (/back/i.test($button.text())
                        && $button.is(":visible")
                        && !$button.hasClass('kb-change-view-button-disabled')) {
                        $button[0].click();
                    }
                });
            };

            $name.off('keyup');
            $number.off('keyup');
            $name.on('keyup', onKeyUp);
            $number.on('keyup', onKeyUp);
        });

        return true;
    }
};

// Scroll to render when user clicks the preview link (mobile only)
var scrollToRenderOnPreviewOnMobile = function () {
    var $previewLinks = $('.kb-unit-preview > .kb-preview');
  
    if ($previewLinks.length) {
        $previewLinks.each(function () {
            var $previewLink = $(this);

            $previewLink.off('click');
            $previewLink.on('click', function (e, trigger) {
                // Assume user click (not script click) if not passed a trigger arg
                if (trigger == null && isMobile()) {
                    scrollToElement($('.kb-preview-panel'));
                }
            });
        });

        return true;
    }
};

// Restrict player number fields to 3 digits, A-Z, or period (.)
var restrictAllPlayerNumberFields = function () {
    var $playerNumberFields = $('.kb-unit-number .kb-text-box');

    if ($playerNumberFields.length) {
        $playerNumberFields.each(function () {
            var $numberField = $(this);

            $numberField.on('keypress', function (event) {
                var allowedKeyCodes = [];
                var keyCode = event.which;

                for (var i = 48; i < 58; i++) { //numbers
                    allowedKeyCodes.push(i);
                }

                for (var i = 65; i < 91; i++) { //A-Z
                    allowedKeyCodes.push(i);
                }

                for (var i = 97; i < 123; i++) { //a-z (we'll uppercase them)
                    allowedKeyCodes.push(i);
                }
                allowedKeyCodes.push(46); // period (.)

                if (!(allowedKeyCodes.indexOf(keyCode) >= 0)) {
                    event.preventDefault();
                }
            });

            $numberField.attr('maxlength', '3');
        });

        return true;
    }
};

// Listen for click on the Add Player button to re-bind event listeners for the following functions:
//  1) Automatic preview and show back when typing player name or number
//  2) Scroll up to render on mobile when user presses preview link
//  3) Restrict player number field to digits only and limited length
repeatUntilTrueOrMaxAttempts(function () {
    var $addPlayerButton = $('.kb-button.kb-add-unit').first();

    if ($addPlayerButton.length) {
        $addPlayerButton.on('click', function () {
            repeatUntilTrueOrMaxAttempts(automaticPreviewViewBackOnPlayerNameOrNumberChange);
            repeatUntilTrueOrMaxAttempts(scrollToRenderOnPreviewOnMobile);
            repeatUntilTrueOrMaxAttempts(restrictAllPlayerNumberFields);
        });

        return true;
    }

    // Call each once on load
    repeatUntilTrueOrMaxAttempts(automaticPreviewViewBackOnPlayerNameOrNumberChange);
    repeatUntilTrueOrMaxAttempts(scrollToRenderOnPreviewOnMobile);
    repeatUntilTrueOrMaxAttempts(restrictAllPlayerNumberFields);
});


// Add a Size Guide button next to the Add Player button (jerseys), or below the size/qty table (shorts)
repeatUntilTrueOrMaxAttempts(function () {

    var $teamDetailsPane = $('.kb-pane-teams:not(.ng-hide)').first();
    var $teamTable = $('.kb-table.kb-teams').first();
    var $metaSizeGuideField = $('.kb-wizard-form-key-meta_sizeguide').first();

    var addButton = function ($parentElement) {
        var sizeGuidePagePath = $metaSizeGuideField.text().trim();
        var $sizeGuideButton = $(
            '<a href="' + sizeGuidePagePath + '" class="kb-button fe-size-guide-button">Size Guide</a>'
        );

        $sizeGuideButton.magnificPopup({
            type: 'ajax',
            midClick: true,
            ajax: {
                cursor: 'mfp-ajax-cur',
                tError: '<p>The size guide could not be loaded.</p>',
            },
            closeOnContentClick: false,
        });
		console.log($sizeGuideButton);
        $parentElement.append($sizeGuideButton);
    };

    if ($teamDetailsPane.length && $metaSizeGuideField.length) {
        var $buttonWrapper = $teamDetailsPane.find('.kb-team-button-wrapper').first();
        addButton($buttonWrapper.length ? $buttonWrapper : $teamDetailsPane.find('.kb-group').first());

        return true;
    } else if ($teamTable.length && $metaSizeGuideField.length) {
        addButton($teamTable.parent());

        return true;
    }
});



// Scroll to render when user clicks a tile picker (usually color swatch) (mobile only)
repeatUntilTrueOrMaxAttempts(function () {
    var $tilePickers = $('.kb-tile-picker-list-item > .kb-tile-picker-label');

    if ($tilePickers.length) {
        $tilePickers.each(function () {
            var $picker = $(this);

            $picker.off('click');
            $picker.on('click', function (e, trigger) {
                // Assume user click (not script click) if not passed a trigger arg
                if (trigger == null && isMobile()) {
                    scrollToElement($('.kb-preview-panel'));
                }
            });
        });

        return true;
    }
});

// Initialise help text meta fields - hide by default and add toggle link
repeatUntilTrueOrMaxAttempts(function () {
    var $helpTextFields = $('.kb-field-meta_helptext');

    if ($helpTextFields.length) {
        $helpTextFields.each(function () {
            var $field = $(this);
            var $contentHeading = $field.find('h3');
            var toggleText = $contentHeading.text(); // Use heading as the toggle link so we can customise the text
            $contentHeading.remove();
            var $content = $field.find('.kb-form-desc').first();

            var $toggle = $('<button class="text-link">' + toggleText + '</button>').on('click', function () {
                if ($content.css('display') === 'inline-block') {
                    $content.css('display', 'none');
                } else if ($content.css('display') === 'none') {
                    $content.css('display', 'inline-block');
                }
            });

            $field.prepend($toggle);
        });

        return true;
    }
});

// Initialise share/save button
repeatUntilTrueOrMaxAttempts(function () {
    var $kbPreviewImage = $('.kb-preview-image').first();

    if ($kbPreviewImage.length) {
        var $shareButton = $('<button class="kb-overlay-button fe-share-design">Save</button>');
        $shareButton.attr('data-gtm-share-design-button', '');

        $shareButton.on('click', function () {
            var link = window.createKbShareLink && window.createKbShareLink();
            if (link) {
                // if (navigator.share) {
                //     navigator.share({
                //         title: 'FE Custom design share',
                //         text: 'Check out this FE Custom design I created!',
                //         url: link,
                //     }).
                //         then(function() {console.log('Successful share')}).
                //         catch(function(error) {console.error('Error sharing', error)});
                // } else {
                var $shareDesign = $('#share-design');
                var $copiedText = $shareDesign.find('.share-design__copiedText').first();
                var $linkInput = $shareDesign.find('.share-design__link').first();
                var $copylinkInput = $shareDesign.find('.share-design__copylink').first();
                var $copyButton = $shareDesign.find('.share-design__copy').first();

                $linkInput.attr('value', link);

                var copyToClipboard = function () {
                    $linkInput.select();
//                   	$copylinkInput.select();
                    document.execCommand("copy");
                    $copiedText.show();
                    $copyButton.hide()
                    setTimeout(function () {
                        $copiedText.fadeOut(1000, function () {
                            $copyButton.show()
                        })

                    }, 500);
                };

                $linkInput.on('click', copyToClipboard);
//               	$copylinkInput.on('click', copyToClipboard);
                $copyButton.on('click', copyToClipboard);

                $.magnificPopup.open({
                    items: {
                        src: '#share-design',
                    },
                    type: 'inline',
                });
                // }
            }
        });

        $kbPreviewImage.append($shareButton);

        return true;
    }
});

// Bind click on customiser accordions in order to scroll the just-opened accordion
// if it is out of view
repeatUntilTrueOrMaxAttempts(function () {
    const $accordionHeaders = $('.kb-wizard-group-header');

    if ($accordionHeaders.length) {
        const buffer = 10;
        const delay = 5;
        const scrollAnimationLength = 200;

        $('.kb-wizard-group-header').click(function () {
            const $accordionTitle = $(this);
            setTimeout(() => {
                const offsetFromViewportTop = $accordionTitle.offset().top - $(window).scrollTop();
                const offsetFromPageTop = $accordionTitle.offset().top - buffer;
                if (offsetFromViewportTop > window.innerHeight || offsetFromViewportTop < 0) {
                    $('html,body').animate({ scrollTop: offsetFromPageTop }, scrollAnimationLength);
                }
            }, delay);
        });

        return true;
    }
});

// Change the supported/accepted formats of image uploads
repeatUntilTrueOrMaxAttempts(function () {
    const $fileInputs = $('input[type=file]');

    if ($fileInputs.length) {
        $fileInputs.each(function () {
            $input = $(this);
            $input.attr('allowed-mime-types', ALLOWED_FILE_MIME_TYPES);
            $input.attr('accept', ALLOWED_FILE_MIME_TYPES);
        });
    }
});

